import { createElement, PropTypes, Component } from 'rlink-react';
import NavLink from 'rlink-router/NavLink';
import { HASH } from 'rlink-router/constants';

import ArticleLink from './ArticleLink';

export default class ArticleNav extends Component {
  render () {
    let {articleSummaries, currentArticleIndex} = this.props;
    let nextArticle = articleSummaries[currentArticleIndex - 1];
    let previousArticle = articleSummaries[currentArticleIndex + 1];
    return (
      <ul className="pagination">
        <ArticleLink
          text="›"
          isDisabled={currentArticleIndex - 1 < 0}
          slug={nextArticle ? nextArticle.slug : ''}
          isExternal={nextArticle ? nextArticle.isExternal : ''}
          externalUrl={nextArticle ? nextArticle.externalUrl : ''}
          onArticleNav={this.props.onArticleNav} />
        <ArticleLink
          text="‹"
          isDisabled={articleSummaries.length <= currentArticleIndex + 1}
          slug={previousArticle ? previousArticle.slug : ''}
          isExternal={previousArticle ? previousArticle.isExternal : ''}
          externalUrl={previousArticle ? previousArticle.externalUrl : ''}
          onArticleNav={this.props.onArticleNav} />
        <li className="close">
          <NavLink
            href={{view: 'home', params: { [HASH]: '#news' }}}
            onClick={this.props.onClose}>✕</NavLink>
        </li>
      </ul>
    );
  }
}

ArticleNav.propTypes = {
  articleSummaries: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    isExternal: PropTypes.bool,
    externalUrl: PropTypes.string,
  })),
  currentArticleIndex: PropTypes.number,
  onClose: PropTypes.func,
  onArticleNav: PropTypes.func,
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/News/ArticleNav.jsx